namespace $.$$ {
	export class $shm_hitalama_map_head extends $.$shm_hitalama_map_head {
		
		sub() {
			this.guest_arg_auto()
			const sub = super.sub()
			return this.editor_mode_enabled()
				? sub.filter( item => item !== this.Widget_list_visible() )
				: sub
		}

		@ $mol_mem
		map_id() {
			return this.map().link().toString()
		}

		edit_widget_arg() {
			return this.$.$mol_state_arg.value( 'edit_widget' )
		}

		guest_token() {
			return 'sUzvXKHzYYgbCHS'
		}

		map_public() {
			return [ 'public_read', 'public_edit' ].includes( this.map().access_level() )
		}

		guest_arg_auto() {
			const guest = this.$.$mol_state_arg.value( 'guest' )
			if( this.map_public() ) {
				if( !guest ) this.$.$mol_state_arg.value( 'guest', this.guest_token() )
			} else if( guest ) {
				this.$.$mol_state_arg.value( 'guest', null )
			}
		}

		widget_list_visible( next?: boolean ) {
			return this.Settings_content().widget_list_visible( next )
		}


		widget_props_visible( next?: boolean ) {
			return this.Settings_content().widget_props_visible( next )
		}

		widget_headers_visible( next?: boolean ) {
			return this.Settings_content().widget_headers_visible( next )
		}

		arrows_visible( next?: boolean ) {
			return this.Settings_content().arrows_visible( next )
		}

		editor_mode_enabled( next?: boolean ) {
			return this.Settings_content().editor_mode_enabled( next )
		}

		open_in_new_uri() {
			const dict = this.$.$mol_state_arg.dict()
			const section = this.$.$mol_state_arg.value( 'section' )
			const uri = section === 'map'
				? this.$.$mol_state_arg.link({ ...dict, section: 'maps' })
				: this.$.$mol_state_arg.link({ ...dict, section: 'map' })
			return uri
		}

		@ $mol_action
		open_in_new_click( event?: MouseEvent ) {
			const invoke = ( this.$.$mol_dom_context.window as any ).__TAURI__?.core?.invoke as
				| ( ( command: string, args?: Record< string, unknown > )=> Promise< unknown > )
				| undefined
			if( !invoke ) return null

			event?.preventDefault()
			const url = new URL( this.open_in_new_uri(), this.$.$mol_dom_context.location.href ).toString()
			invoke( 'open_external', { url } ).catch( $mol_fail_log )
			return null
		}
		
	}
}
